import React from 'react';
import { Button, Form, Input } from 'antd';
import Drawer from '../../../components/AppDrawer';
import type { CreateHostTenantRequest } from '../../tenants/api/tenants';

interface CreateHostTenantDrawerProps {
  open: boolean;
  onClose: () => void;
  onSave: (values: CreateHostTenantRequest) => void;
  saving: boolean;
}

const CreateHostTenantDrawer: React.FC<CreateHostTenantDrawerProps> = ({
  open,
  onClose,
  onSave,
  saving,
}) => {
  const [form] = Form.useForm<CreateHostTenantRequest>();

  function handleClose() {
    form.resetFields();
    onClose();
  }

  return (
    <Drawer
      title="Create tenant"
      size="large"
      placement="right"
      open={open}
      onClose={handleClose}
      destroyOnClose
      footer={(
        <div style={{ textAlign: 'right' }}>
          <Button onClick={handleClose} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" loading={saving} onClick={() => form.submit()}>
            Create tenant
          </Button>
        </div>
      )}
    >
      <div className="cp-form-section">
        <Form form={form} layout="vertical" onFinish={onSave}>
          <Form.Item name="companyName" label="Company name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="primaryContactFirstName" label="Primary contact first name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="primaryContactLastName" label="Primary contact last name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="primaryContactEmail" label="Primary contact email" rules={[{ required: true, type: 'email' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="phone" label="Phone">
            <Input />
          </Form.Item>
        </Form>
      </div>
    </Drawer>
  );
};

export default CreateHostTenantDrawer;
